import { render, staticRenderFns } from "./ModalSubPartita.vue?vue&type=template&id=b2817a36"
import script from "./ModalSubPartita.vue?vue&type=script&lang=js"
export * from "./ModalSubPartita.vue?vue&type=script&lang=js"
import style0 from "./ModalSubPartita.vue?vue&type=style&index=0&id=b2817a36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports